import DocumentTableHeader from 'components/global/headers/DocumentTable'
import DocumentTable from 'components/global/Tables/DocumentTable'
import React from 'react'
import { useParams } from 'react-router-dom'

const Documents: React.FC = () => {
  const { id }: { id: string } = useParams()
  return (
    <div className="bg-grey container padding-top-10">
      <div className="profile_container">
        <DocumentTableHeader />
        <DocumentTable memberId={id} />
      </div>
    </div>
  )
}

export default Documents
